import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Forces owner/admin users without verified TOTP to land on /account/security.
 * DEMO tenant users are explicitly excluded (see AuthContext.isDemo logic).
 *
 * Lives outside ProtectedRoute on purpose — DO-NOT-TOUCH for that file.
 */
export function MfaGate({ children }: { children: ReactNode }) {
  const { user, mustEnrollMfa, loading } = useAuth();
  const location = useLocation();

  if (loading || !user || !mustEnrollMfa) return <>{children}</>;

  const path = location.pathname;
  const allowed =
    path === '/account/security' ||
    path === '/login' ||
    path === '/logout' ||
    path === '/register' ||
    path === '/forgot-password' ||
    path === '/reset-password';

  if (allowed) return <>{children}</>;
  return <Navigate to="/account/security?force=true" replace />;
}
